export enum SetJobTargetFlowType {
    Manual = 1,
    Guided,
    MultipleContributor,
    BenchmarkProfile
}

export enum SetJobTargetStep {
    Behavioral = 1,
    Cognitive
}
